/**
 * Integration Secrets — mounted at /app/maud-erp/integration-secrets.
 * Who may open it is decided by the menu grant, checked again by the server.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const IntegrationSecrets = lazy(() => import('../pages/IntegrationSecrets'));

export const integrationSecretsRoutes: RouteObject[] = [
  { index: true, element: <IntegrationSecrets /> },
];

export default integrationSecretsRoutes;
